import { render, staticRenderFns } from "./basicStatistics.vue?vue&type=template&id=1335daf4"
import script from "./basicStatistics.vue?vue&type=script&lang=js"
export * from "./basicStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports